import { useFetcher } from "@remix-run/react";
import { Button } from "./ui/button";
import type { Job, JobActions } from "~/db/types";
import { Check } from "lucide-react";

export function ApplyButton({
  job,
  isCandidate,
}: {
  job: Job & JobActions;
  isCandidate: boolean;
}) {
  const applyJobFetcher = useFetcher();

  const isApplying =
    applyJobFetcher.formData?.get("_intent") === "apply" && isCandidate;

  return (
    <div>
      <applyJobFetcher.Form method="post">
        <input type="hidden" name="jobId" value={job.id} />

        {job.applied || isApplying ? (
          <Button size={"sm"} className="pointer-events-none">
            <Check /> Applied
          </Button>
        ) : (
          <Button
            name="_intent"
            type="submit"
            size={"sm"}
            value={`apply`}
            variant={"outline"}
          >
            Apply Now
          </Button>
        )}
      </applyJobFetcher.Form>
    </div>
  );
}
